import { render, staticRenderFns } from "./askQuestion.vue?vue&type=template&id=7cc61d84&scoped=true&"
import script from "./askQuestion.vue?vue&type=script&lang=js&"
export * from "./askQuestion.vue?vue&type=script&lang=js&"
import style0 from "./askQuestion.vue?vue&type=style&index=0&id=7cc61d84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc61d84",
  null
  
)

export default component.exports